import { jsx as _jsx } from "react/jsx-runtime";
import { createRoot } from 'react-dom/client';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { LoadingProvider } from './context&providers/providers/Loading';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { store } from './store';
import { Provider } from 'react-redux';
var rootElement = document.getElementById('root');
var root = createRoot(rootElement);
root.render(_jsx(Provider, { store: store, children: _jsx(LocalizationProvider, { dateAdapter: AdapterDayjs, children: _jsx(LoadingProvider, { children: _jsx(BrowserRouter, { children: _jsx(App, {}) }) }) }) }));
